// assets/postcode-map.js
// Simple postcode-to-inspector mapping for Mal Crawford.

window.EPC_POSTCODE_MAP = {
    "4209-4230": "/pages/malcrawford",

  "4567": "/pages/diego",
  "4566": "/pages/diego",
  "4573": "/pages/diego",
  "4561": "/pages/diego",
  "4562": "/pages/diego",
  "4560": "/pages/diego",
  "4554": "/pages/diego",
  "4558": "/pages/diego",
  "4574": "/pages/diego",
  "4555": "/pages/diego",
  "4552": "/pages/diego",
  "4551": "/pages/diego",
  "4557": "/pages/diego",
  "4556": "/pages/diego",
  "4575": "/pages/diego",
  "4572": "/pages/diego",
  "4558": "/pages/diego",
  "4553": "/pages/diego",
  "4504": "/pages/diego",
  "4564": "/pages/diego",
  "4559": "/pages/diego",
  "4019": "/pages/diego",
  "4020": "/pages/diego",
  "4021": "/pages/diego",
  "4022": "/pages/diego",
  "4505": "/pages/diego",
  "4506": "/pages/diego",
  "4507": "/pages/diego",
  "4508": "/pages/diego",
  "4509": "/pages/diego",
  "4510": "/pages/diego",
  "4511": "/pages/diego",
  "4519": "/pages/diego",
  "4550": "/pages/diego",
  "4517": "/pages/diego",
  "4516": "/pages/diego",
  "4518": "/pages/diego"

};
